import React, { Component } from "react"
import PropTypes from "prop-types"

export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || ""

class Turnstile extends Component {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.widgetId = null
    this.retryTimer = null
  }

  componentDidMount() {
    this.renderWidget()
  }

  componentWillUnmount() {
    if (this.retryTimer) {
      clearTimeout(this.retryTimer)
      this.retryTimer = null
    }
    if (window.turnstile && this.widgetId != null) {
      window.turnstile.remove(this.widgetId)
      this.widgetId = null
    }
  }

  renderWidget = () => {
    if (!TURNSTILE_SITE_KEY) return

    // The Cloudflare script loads async from index.html, so it may not be ready on first mount.
    if (!window.turnstile || !this.containerRef.current) {
      this.retryTimer = setTimeout(this.renderWidget, 200)
      return
    }

    this.widgetId = window.turnstile.render(this.containerRef.current, {
      sitekey: TURNSTILE_SITE_KEY,
      theme: "light",
      callback: token => this.props.onVerify(token),
      "expired-callback": () => this.props.onVerify(null),
      "error-callback": () => this.props.onVerify(null),
    })
  }

  // Tokens are single-use, so call this after every submit to get a fresh one.
  reset = () => {
    this.props.onVerify(null)
    if (window.turnstile && this.widgetId != null) {
      window.turnstile.reset(this.widgetId)
    }
  }

  render() {
    if (!TURNSTILE_SITE_KEY) return null
    return <div className="login-turnstile" ref={this.containerRef} />
  }
}

Turnstile.propTypes = {
  onVerify: PropTypes.func.isRequired,
}

export default Turnstile
